import { gql } from '@apollo/client';

export const ADD_ATTENDEES_TO_SESSION = gql`
  mutation addAttendeesToSession($input: AddAttendeesToSessionInput!) {
    session: addAttendeesToSession(input: $input) {
      id
    }
  }
`;
